import { Link } from "react-router-dom";
import React, {Fragment} from 'react';
import {Skeleton} from "@mui/material";
import {empty_bk, FormatNumberByhkh,scrollTo_element} from "../../clientconfigwebapp";
import avator_img from "../../assets/img/avator-img.png";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import '../assets/css/Comments.css'

import Comments_reply from  "./Comments-reply";
import $ from "jquery";
const Comments_bk = (props) => {

    let link_post_get="/"+props.link_to;
    link_post_get=link_post_get.replaceAll("//","")


    const handleClick_reply_comment = (event)=>{

        $(document).ready(function() {

      $("#parent_get").val(String(event.target.value));

        });

        scrollTo_element("parent_get");



    };

    return (
        <Fragment>





            {
                String(props.data_info_list).length==0 ?  (

                <Fragment>

                    <span style={{"display":"block","width":"100%","textAlign":"center","padding":"23px","color":"#595959","borderRadius":"4px","fontSize":"14px","backgroundColor":"white","border":"solid 1px #ffd5d5"}}>نظر برای این پست پیدا نشد.</span>

                </Fragment>

            ) : (
                <Fragment>


                    {

                        props.data_info_list.map((item_comment_curent,index) => {


                            return (
                                <Fragment>
                                    <div className="flexColStartStart w-100 sin-mu-com-wrapper">

                                        {/*<img src={avator_img} />*/}

                                        <div className="flexRowBetStart w-100 sin-mu-com">
                                            <div className="flexRowBetCenter box-comment-section">
                                                <AccountCircleIcon style={{"fontSize":"56px","color":"#bebebe","marginLeft":"12px"}}/>
                                                <div className="flexColStartStart sin-mu-com-info">
                                                    <span style={{"display":"block","marginBottom":"10px","width":"100%","color":"rgb(147 143 143)","fontFamily":"iran"}}>{item_comment_curent.first_and_last_name}</span>
                                                    <p style={{"lineHeight":"1.6"}}>{item_comment_curent.description}</p>
                                                </div>


                                            </div>

                                            {/*<p>تاریخ : <span>{item_comment_curent.date_post_get}</span></p>*/}
                                        </div>


                                        <button  value={item_comment_curent._id} onClick={handleClick_reply_comment}   style={{"width":"99px","marginBottom":"16px","textAlign":"center","fontSize":"10px","marginTop":"3px","height":"29px","paddingTop":"5px"}} className="btn-bh btn-grey-bh">
                                            پاسخ
                                        </button>



                                    </div>


                                    <Comments_reply data_info_list={item_comment_curent.childs_comment}   />


                                </Fragment>

                            )

                        })

                    }




                </Fragment>

            ) }

        </Fragment>
    );

}
export default Comments_bk;

